import { Injectable } from '@angular/core';
import { EntityType } from '../../shared/enums/entity-type.enum';

import { APP_CONFIG } from '../../app.config';
import { RequestService } from '../../shared/services/request.service';
import { Password } from './models/password.model';

@Injectable()
export class PasswordService {
  constructor(private requestService: RequestService) {}

  async getPasswords(storeUuid: string, entityType: EntityType): Promise<Password[]> {
    const params: any = {
      storeUuid: storeUuid,
      type: entityType,
    };
    const urlRequest = this.requestService.buildUrlPathParams(
      params,
      APP_CONFIG.WEBSERVICE.PASSWORDS
    );
    let response = await this.requestService.getData(urlRequest);
    const passwords: Password[] = [];
    if (response && response.length > 0) {
      for (const resp of response) {
        passwords.push(new Password(resp, entityType));
      }
    }
    console.log(passwords);
    return passwords || [];
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/passwords/passwords.service.ts